import { spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const styles: Record<string, CSSProperties> = {
    input: {
      cursor: "pointer",
      userSelect: "none",
    },
    text: {
      textAlign: "center",
    },
    bank: {
      paddingTop: spacing.m,
      paddingBottom: spacing.m,
      pointerEvents: "none",
    },
  };

  return styles;
};
